import type { StyleTheme } from "@/interfaces";

/**
 * Theme configuration for different style themes
 */
export interface ThemeConfig {
  name: StyleTheme;
  colors: {
    primary: string;
    primaryLight: string;
    activeTabBg: string;
  };
  buttonRadius: string;
  loading: {
    type: "spinner" | "coin";
    coinImage?: string;
    ringColor?: string;
  };
  success: {
    type: "lottie" | "image";
    lottiePath?: string;
    imagePath?: string;
  };
}

/**
 * Theme definitions for all available style themes
 */
export const THEME_CONFIGS: Record<StyleTheme, ThemeConfig> = {
  superplay: {
    name: "superplay",
    colors: {
      primary: "#49BDF3",
      primaryLight: "#49BDF3",
      activeTabBg: "#DAF3FE",
    },
    buttonRadius: "6px",
    loading: {
      type: "spinner",
    },
    success: {
      type: "lottie",
      lottiePath: "/lottie/success-icon.lottie",
    },
  },
  "merge-cruise": {
    name: "merge-cruise",
    colors: {
      primary: "#2959D1",
      primaryLight: "#2959D1",
      activeTabBg: "#C3D4FF",
    },
    buttonRadius: "9999px",
    loading: {
      type: "coin",
      coinImage: "/img/merge-cruise-loading.png",
      ringColor: "#2959D1",
    },
    success: {
      type: "lottie",
      lottiePath: "/lottie/merge-cruise-success.lottie",
    },
  },
};

/**
 * Get theme configuration by style theme name
 * @param styleTheme - The style theme name (defaults to "superplay")
 * @returns The theme configuration
 */
export function getThemeConfig(styleTheme?: StyleTheme): ThemeConfig {
  return THEME_CONFIGS[styleTheme || "superplay"];
}

/**
 * Check if the current theme is merge-cruise
 * @param styleTheme - The style theme name
 * @returns true if merge-cruise theme
 */
export function isMergeCruiseTheme(styleTheme?: StyleTheme): boolean {
  return styleTheme === "merge-cruise";
}
